import {useState, useEffect} from 'react';
import axios from "axios"

// This hook use for api call

const useFetchBlock =(url)=>{

    const [data,setData] = useState(null)
    const [error,setError] = useState(null)
    const [loading,setLoading] = useState(false)
    useEffect(() => {
        if(url){
            (
                async function(){
                    try{
                        setLoading(true)
                        const response = await axios.get(url)
                        setData(response.data)
                    }catch(err){
                        setError(err)
                    }finally{
                        setLoading(false)
                    }
                }
            )()
        }
    }, [url])

    return { data, error, loading }
}
export default useFetchBlock;